import React from 'react';
import './loading.css';

const Loading = () => {
  return <div className="loading"></div>;
};

export default Loading;
